import clsx from 'clsx'

export type SideNavSectionProps = {
  /** Content to render inside the section */
  children: React.ReactNode
  /** Additional className */
  className?: string
}

/**
 * A section container for grouping navigation items.
 *
 * Handles the border styling and spacing between groups.
 * Used to visually separate different areas of the sidebar.
 */
export function SideNavSection({ children, className }: SideNavSectionProps) {
  return <div className={clsx('flex flex-col border-r', className)}>{children}</div>
}

/**
 * A visual divider between sidebar sections.
 *
 * Creates a horizontal line with a gap on the right
 * to maintain the visual border styling of the sidebar.
 */
export function SideNavDivider() {
  return (
    <div className="flex flex-col">
      {/* Spacer to create a visual gap in the vertical border */}
      <div className="h-4" />
      {/* Horizontal divider with a visual gap on the right */}
      <div className="flex h-4">
        <div className="w-full border-t mr-4" />
      </div>
    </div>
  )
}

export type SideNavSpacerProps = {
  /** Height of the spacer in pixels - defaults to 16px (h-4) */
  height?: number
}

/**
 * A simple spacer component for visual gaps.
 */
export function SideNavSpacer({ height = 14 }: SideNavSpacerProps) {
  return <div style={{ height }} />
}
